/**
 * dynamic js module loader if required
 * @param {string} selector selector of required el to load the script
 * @param {Function} load load function
 */
export function loadScript(selector, load) {
  const elementsArr = document.querySelectorAll(selector);
  if (elementsArr.length <= 0) return Promise.resolve(null);

  // console.log(`Loading module for "${selector}" selector`);

  return load().then(({ default: ScriptClass }) => {
    return new ScriptClass();
  });
}

export default {
  loadScript,
};
